import { createContext } from 'react';

/**
 * Session context.
 *
 * @typedef {object} SessionValue
 * @property {'loading'|'signed-out'|'signed-in'} status
 * @property {object|null} user
 * @property {{id: string, expiresAt: string, daysRemaining: number}|null} session
 * @property {string|null} error       Safe to show. Null unless the check itself failed.
 * @property {() => Promise<void>} refresh
 * @property {(input: {email: string, password: string}) => Promise<void>} signIn
 * @property {(input: {email: string, password: string, displayName: string}) => Promise<void>} signUp
 * @property {() => Promise<void>} signOut
 */

/** @type {import('react').Context<SessionValue | null>} */
export const SessionContext = createContext(null);
